import { css } from '@emotion/react';
import { spacing, colors, fontStyles } from '../../../../styles';
import { TimeRange } from '../../../../types';

export const timeRangeDisplay: Record<TimeRange, string> = {
  [TimeRange.days1]: 'past day',
  [TimeRange.weeks1]: 'past week',
  [TimeRange.months1]: 'past month',
  [TimeRange.months3]: 'past 3 mo',
  [TimeRange.months6]: 'past 6 mo',
  [TimeRange.ytd]: 'YTD',
  [TimeRange.years1]: 'past year',
  [TimeRange.years5]: 'past 5 yrs',
};

// Shared constants for consistent theming
export const SENTIMENT_COLORS = {
  positive: colors.leaf,
  negative: colors.berry,
  neutral: colors.earth,
  info: colors.petrolBlue,
  muted: colors.silver,
} as const;

export const SHARED_STYLES = {
  loading: css`
    ${fontStyles.mouse}
    color: ${SENTIMENT_COLORS.muted};
  `,
  cardContainer: css`
    display: flex;
    gap: ${spacing.deci};
    margin-bottom: ${spacing.deci};
  `,
  metricCard: css`
    flex: 1;
    padding: ${spacing.centi};
    background: ${colors.fog};
    border-radius: 6px;
    text-align: center;

    html[data-theme='dark'] & {
      background: var(--card-background);
    }
  `,
  metricValue: css`
    font-weight: 600;
    font-size: 18px;
    font-family: monospace;
    font-variant-numeric: tabular-nums;
    margin-bottom: ${spacing.milli};
    display: block;
  `,
  metricLabel: css`
    ${fontStyles.flea}
    color: ${SENTIMENT_COLORS.muted};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  `,
  sentimentCard: css`
    padding: ${spacing.deci};
    background: white;
    border-radius: 8px;

    html[data-theme='dark'] & {
      background: var(--card-background);
    }
  `,
  sectionHeader: css`
    ${fontStyles.cat}
    font-weight: 600;
    margin-bottom: ${spacing.centi};
  `,
} as const;

// Import SVG icons for todo status
export { default as AverageIcon } from '../../../RatingIndicator/defaultImages/average.svg';
export { default as FavorableIcon } from '../../../RatingIndicator/defaultImages/favorable.svg';
export { default as DangerousIcon } from '../../../RatingIndicator/defaultImages/dangerous.svg';
